import { applyToneMark } from "@-/com.npmjs.kensio__pinyinjs";

/** Tone marked by a pinyin diacritic; neutral tone has no mark. */
export type DiacriticTone = 1 | 2 | 3 | 4;

/** PinyinJS supplies the Unicode tone spellings, including syllabic nasals and ê. */
export const DIACRITIC_TONE_DICT: Record<string, DiacriticTone> = Object.fromEntries(
  ["a", "e", "i", "o", "u", "ü", "m", "n", "ê"].flatMap((letter) =>
    ([1, 2, 3, 4] as const).flatMap((tone) => {
      const marked = applyToneMark(letter, tone);
      return [
        [marked, tone],
        [marked.toUpperCase(), tone],
      ] as const;
    }),
  ),
);
